import { render, staticRenderFns } from "./page-header.vue?vue&type=template&id=9c9625f0&scoped=true"
import script from "./page-header.vue?vue&type=script&lang=js"
export * from "./page-header.vue?vue&type=script&lang=js"
import style0 from "./page-header.vue?vue&type=style&index=0&id=9c9625f0&prod&lang=scss&scoped=true"
import style1 from "./page-header.vue?vue&type=style&index=1&id=9c9625f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9625f0",
  null
  
)

export default component.exports